import { useEffect, useState } from 'react';

export type MessageType<T extends object> = {
  action: keyof typeof CHANNEL_ACTIONS;
  payload: T;
};

class BroadcastChannelTyped extends BroadcastChannel {
  public postMessage(message: MessageType<any>): void {
    return super.postMessage(message);
  }
}

enum CHANNEL_TYPES {
  EXPLORER = 'EXPLORER',
  GLOBAL_DATA = 'GLOBAL_DATA',
}

enum CHANNEL_ACTIONS {
  EXPLORER_ADD_NODE = 'EXPLORER_ADD_NODE',
  EXPLORER_RENAME_NODE = 'EXPLORER_RENAME_NODE',
  EXPLORER_DELETE_NODE = 'EXPLORER_DELETE_NODE',
  GLOBAL_DATA_UPDATE = 'GLOBAL_DATA_UPDATE',
}

const CHANNEL_STATE = {
  [CHANNEL_ACTIONS.EXPLORER_RENAME_NODE]: {
    action: CHANNEL_ACTIONS.EXPLORER_RENAME_NODE,
    payload: {
      node: null,
    },
  },
  [CHANNEL_ACTIONS.GLOBAL_DATA_UPDATE]: {
    action: CHANNEL_ACTIONS.GLOBAL_DATA_UPDATE,
    payload: {
      updatedEntity: null,
    },
  },
};

const useBroadcast = (channel: keyof typeof CHANNEL_TYPES): BroadcastChannelTyped => {
  const [broadcast, setBroadcast] = useState(null);

  useEffect(() => {
    const bc = new BroadcastChannelTyped(channel);
    setBroadcast(bc);
    return () => {
      bc.close();
    };
  }, [channel]);

  return broadcast;
};

export default useBroadcast;
export { CHANNEL_STATE, CHANNEL_ACTIONS, CHANNEL_TYPES, BroadcastChannelTyped };
